module.exports = __webpack_public_path__ + "img/23EF.811ba169.svg";